import React, { useState, useEffect, useContext } from "react";
import "./Squares.scss";
// import plus from "../../assets/plus.svg";
// import x from "../../assets/x.svg";
import { SquareContext } from "../../SquareContext";
// import granity from "../Granity";
// import gr from "../../assets/gr.svg"

function Squares(props) {
  

  const { cartItems, addSquare, setAddSquare, listItems, cart } = useContext(SquareContext);

  const handleClick = () => {
    if (!addSquare) {
      setAddSquare(true);
    } else {
      setAddSquare(false);
    }
  };



  return (
    <div className="squares">
      <div className="square-col">
        {!cartItems[0] ? (
          <div className="square-cont">
            <div onClick={props.first} className="first-square"></div>
            <p></p>
          </div>
        ) : (
         cartItems[0]
        )}
      </div>
      <div className="square-col">
        {!cartItems[1] ? (
          <div className="square-cont">
            <div onClick={props.second} className="second-square"></div>
            <p></p>
          </div>
        ) : (
          cartItems[1]
        )}
      </div>
      <div className="square-col">
        {!cartItems[2] ? (
          <div className="square-cont">
            <div  onClick={props.third} className="third-square"></div>
            <p></p>
          </div>
        ) : (
          cartItems[2]
        )}
      </div>
      <div className="test-form">{listItems}</div>
    </div>
  );
}

export default Squares;

// style={{
//   backgroundImage: `url(${squareState.img})`,
//   backgroundSize: squareState.size,
//   border: squareState.border,
//   padding: squareState.pad,
//   width: squareState.width,
//   height: squareState.height,
// }}
